import {
  CollectionReference,
  DocumentData,
  addDoc,
  setDoc,
  collection,
  deleteDoc,
  getDocs,
  doc,
  updateDoc,
  query,
  where,
  and,
  or,
  startAt,
  startAfter,
  limit,
  limitToLast,
  orderBy,
  getDoc,
  onSnapshot,
  WhereFilterOp,
  getCountFromServer,
  WriteBatch,
  writeBatch,
  collectionGroup
} from '@angular/fire/firestore';

import { Firestore, collectionData, docData, collectionSnapshots, collectionChanges } from '@angular/fire/firestore';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { getLocaleDirection } from '@angular/common';
import { AppService } from './app.service';

interface User {
  id: string;
  email: string;
  clients?: CollectionReference<DocumentData>;
}

@Injectable({
  providedIn: 'root'
})
export class FirestoreDbService {

  private users?: CollectionReference<DocumentData>;
  private clients?: CollectionReference<DocumentData>;
  private tokens?: CollectionReference<DocumentData>;
  private relations?: CollectionReference<DocumentData>;
  private invitations?: CollectionReference<DocumentData>;
  public auth: any | undefined;
  public isAdmin = false;

  private collections: any = {}
  defaultLimit = false;

  public get fs() {
    return this.firestore;
  }

  constructor(
    public readonly firestore: Firestore,
  ) {
    console.log('🚀 ~ FirestoreDbService ~ this.firestore:', this.firestore);
    // this.users = collection(this.firestore, 'users');
    // this.clients = collection(this.firestore, 'clients');
    // this.tokens = collection(this.firestore, 'tokens');
    // this.relations = collection(this.firestore, 'users_clients');
    // this.invitations = collection(this.firestore, 'invitations');
    // this.collections.users = this.users;
    // this.collections.clients = this.clients;
    // this.collections.tokens = this.tokens;
    // this.collections.relations = this.relations;
    // this.collections.invitations = this.invitations;
  }

  async checkIsAdmin(user: any) {
    if (user && user.superuser && user.superuser === true) {
      return true;
    }

    let docRef: any;

    try {
      docRef = await this.get('admins', user.id);
    } catch (e: any) {
      return false;
    }

    if (docRef.exists()) {
      const docData: any = docRef.data();
      if (docData && docData.role.includes('admin')) {
        this.isAdmin = true;
        return true;
      }
    }

    return false;
  }

  async getAll(dataType: string): Promise<any> {
    const clients: any[] = [];
    const relations = await getDocs(query(collection(this.firestore, 'users_clients'), where('user', '==', this.auth.id)));
    relations.forEach(async (token: any) => {
      const data: any = token.data();
      if (data.client) {
        const docRef = doc(this.firestore, `${dataType}/${data.client}`);
        const client = await getDoc(docRef);
        const clientData = client.data();
        clients.push(clientData);
      }
    });
    return new Promise<any>((resolve) => {
      resolve(clients);
    });

    // .then((documents: any) => {
    //   documents.forEach((doc: any) => {

    //   })
    // })
    // return collectionData(this.collections[dataType], {
    //   idField: 'id',
    // }) as Observable<any>;
  }

  async getAllClients(nameFilter?: string): Promise<any> {

    const clients: any[] = [];
    if (!this.auth || !this.auth.id) {
      return new Promise<any>((resolve) => {
        resolve(clients);
      });
    }

    if (this.isAdmin) {

      let allClientsQuery;
      if (nameFilter && nameFilter.trim()) {
        // Filtrar por domain si se proporciona
        allClientsQuery = query(
          collection(this.firestore, 'clients'),
          where('domain', '>=', nameFilter.trim()),
          where('domain', '<=', nameFilter.trim() + '\uf8ff')
        );
      } else {
        // Sin filtro, obtener solo los primeros 50
        allClientsQuery = query(
          collection(this.firestore, 'clients'),
          limit(50)
        );
      }

      const allClients = await getDocs(allClientsQuery);
      allClients.forEach((clientDoc: any) => {
        const clientData: any = clientDoc.data();
        if (clientData) {
          clientData.id = clientDoc.id;
          clients.push(clientData);
        }
      });

      return new Promise<any>((resolve) => {
        resolve(clients);
      });
    }

    const relations = await getDocs(query(collection(this.firestore, 'users/' + this.auth.id + '/clients')));
    // const relations = await getDocs(query(collection(this.firestore, 'clients'), where('')));
    // const relations = await getDocs(query(collection(this.firestore, 'clients/CFGTg7U/users')));
    for (let i = 0, l = relations.size; i < l; i++) {
      const token = relations.docs[i];
      const data: any = token.data();
      if (data.client && data.client > "" && data.accepted) {
        try {
          const docRef = doc(this.firestore, `clients/${data.client}`);
          const client = await getDoc(docRef);
          const clientData: any = client.data();
          if (clientData) {
            // Aplicar filtro por domain también para usuarios no admin
            if (!nameFilter || !nameFilter.trim() ||
              (clientData.domain && clientData.domain.toLowerCase().includes(nameFilter.toLowerCase()))) {
              clientData.accepted = data.accepted ? data.accepted : false;
              clients.push(clientData);
            }
          }
        } catch (error) {
          console.log('🚀 ~ FirestoreDbService ~ getAllClients ~ `clients/${data.client}`:', `clients/${data.client}`);
        }
      }
    }
    // relations.forEach(async (token: any) => {
    //   const data: any = token.data();
    //   if (data.client && data.client > "" && data.accepted) {
    //     const docRef = doc(this.firestore, `clients/${data.client}`);
    //     const client = await getDoc(docRef);
    //     const clientData: any = client.data();
    //     if (clientData) {
    //       clientData.accepted = data.accepted ? data.accepted : false;
    //       clients.push(clientData);
    //     }
    //   }
    // });
    return new Promise<any>((resolve) => {
      resolve(clients);
    });
  }

  async checkId(collectionPath: string, id: string): Promise<boolean> {
    const docReference = doc(this.firestore, `${collectionPath}/${id}`);
    const exists = await getDoc(docReference);
    return exists.exists();
  }

  async getCollection(dataType: string): Promise<any> {
    const clients: any[] = [];
    const relations = await getDocs(query(collection(this.firestore, dataType)));
    relations.forEach(async (token: any) => {
      const data: any = token.data();
      if (!data.id) {
        data.id = token.id;
      }
      clients.push(data);
    });
    return new Promise<any>((resolve) => {
      resolve(clients);
    });

    // .then((documents: any) => {
    //   documents.forEach((doc: any) => {

    //   })
    // })
    // return collectionData(this.collections[dataType], {
    //   idField: 'id',
    // }) as Observable<any>;
  }

  get(dataType: string, id: string) {
    const docReference = doc(this.firestore, `${dataType}/${id}`);
    return getDoc(docReference);
  }

  query(dataType: string, fld: any = false, op: WhereFilterOp = '==', val: any = false, order: any = false, startRec: any = false, limitRecs: any = this.defaultLimit) {
    if (fld !== false) {
      const whereConds: any[] = [];
      if (Array.isArray(fld)) {
        fld.forEach((val: any) => {
          whereConds.push(where(val.fld, val.op, val.val));
        });
      } else {
        whereConds.push(where(fld, op, val));
      }
      if (order !== false) {
        if (typeof order === 'string') {
          if (startRec) {
            if (limitRecs) {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order), startAfter(startRec), limit(limitRecs)));
            } else {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order), startAfter(startRec)));
            }
          } else {
            if (limitRecs) {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order), limit(limitRecs)));
            } else {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order)));
            }
          }
        } else if (Array.isArray(order)) {
          if (startRec) {
            if (limitRecs) {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1]), limit(limitRecs), startAfter(startRec)));
            } else {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1]), startAfter(startRec)));
            }
          } else {
            if (limitRecs) {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1]), limit(limitRecs)));
            } else {
              return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1])));
            }
          }
        }
      }
      return getDocs(query(collection(this.firestore, dataType), ...whereConds));
    } else {
      return getDocs(query(collection(this.firestore, dataType)));
    }
  }

  getByFld(dataType: string, fld: string, val: string, op = '==') {
    return getDocs(query(collection(this.firestore, dataType), where(fld, '==', val)));
    // return docData(docReference);
  }

  parseConditions(conditions: any[]) {
    let whereConds: any[] = [];
    conditions.forEach((cond: any) => {
      if (Array.isArray(cond)) {
        // const conds: any = [];
        // cond.forEach((v: any) => {
        //   conds.push(where(v.fld, v.op, v.val));
        // });
        if (cond[0].type && cond[0].type == 'or') {
          // whereConds.push(or(...conds));
          whereConds = [and(...whereConds, or(...this.parseConditions(cond)))];
        } else if (cond[0].type && cond[0].type == 'and') {
          // whereConds.push(or(...conds));
          whereConds = [and(...whereConds, and(...this.parseConditions(cond)))];
        } else {
          whereConds = [...whereConds, ...this.parseConditions(cond)];
        }
      } else {
        whereConds.push(where(cond.fld, cond.op, cond.val));
      }
    });
    return whereConds;
  }

  queryCollection(dataType: string, fld: any = false, op: WhereFilterOp = '==', val: any = false, order: any = false, startRec: any = false, limitRecs: any = this.defaultLimit) {

    const options: any[] = [
      // this.firestore,
      // dataType,
    ];
    if (fld !== false) {
      let whereConds: any[] = [];
      if (Array.isArray(fld)) {
        whereConds = this.parseConditions(fld);
        // fld.forEach((val: any) => {
        //   whereConds.push(where(val.fld, val.op, val.val));
        // });
      } else {
        whereConds.push(where(fld, op, val));
      }
      options.push(...whereConds);
    }
    if (order !== false) {
      if (typeof order === 'string') {
        options.push(orderBy(order));
      } else if (Array.isArray(order)) {
        options.push(orderBy(order[0], order[1]));
      }
    }
    if (startRec) {
      options.push(startAfter(startRec));
    }
    if (limitRecs) {
      options.push(limit(limitRecs));
    }
    return getDocs(query(collection(this.firestore, dataType), ...options));

    //   // let qry: any = query(this.collections[dataType]);
    //   if (fld !== false)  {
    //     const whereConds: any[] = [];
    //     if (Array.isArray(fld)) {
    //       fld.forEach((val: any) => {
    //         whereConds.push(where(val.fld, val.op, val.val));
    //       });
    //     } else {
    //       whereConds.push(where(fld, op, val));
    //     }
    //     if (order !== false) {
    //       if (typeof order === 'string') {
    //         if (startRec) {
    //           if (limitRecs) {
    //             return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order), startAfter(startRec), limit(limitRecs)));
    //           } else {
    //             return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order), startAfter(startRec)));
    //           }
    //         } else if (limitRecs) {
    //           return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order), limit(limitRecs)));
    //         } else {
    //           return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order)));
    //         }
    //       } else if (Array.isArray(order)) {
    //         if (limitRecs) {
    //           return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1]), startAfter(startRec), limit(limitRecs)));
    //         } else {
    //           return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1]), startAfter(startRec)));
    //         }
    //       } else if (limitRecs) {
    //         return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1]), limit(limitRecs)));
    //       } else {
    //         return getDocs(query(collection(this.firestore, dataType), ...whereConds, orderBy(order[0], order[1])));
    //       }
    //     } else {
    //       if (startRec)
    //       return getDocs(query(collection(this.firestore, dataType, ...whereConds)));
    //   }
    // } else {
    //     return getDocs(query(collection(this.firestore, dataType)));
    //   }
  }

  queryCollectionCount(dataType: string, fld: any, op: WhereFilterOp = '==', val: any = false) {
    // let qry: any = query(this.collections[dataType]);
    const whereConds: any[] = [];
    if (Array.isArray(fld)) {
      fld.forEach((val: any) => {
        whereConds.push(where(val.fld, val.op, val.val));
      });
    } else {
      whereConds.push(where(fld, op, val));
    }
    return getCountFromServer(query(collection(this.firestore, dataType), ...whereConds));
  }

  getCollectionCount(dataType: string) {
    // let qry: any = query(this.collections[dataType]);
    return getCountFromServer(query(collection(this.firestore, dataType)));
  }

  store(dataType: string, data: any, merge = false) {
    const docReference = doc(this.firestore, `${dataType}`, data.id);
    return setDoc(docReference, data, { merge: merge });
  }

  batchStore(dataType: string, data: any, merge = false) {
    const batch = writeBatch(this.firestore);
    data.forEach((d: any) => {
      const docReference = doc(this.firestore, `${dataType}`, d.id);
      batch.set(docReference, d, { merge: merge });
    });
    return batch.commit();
    // const docReference = doc(this.firestore, `${dataType}`, data.id);
    // return setDoc(docReference, data, { merge: merge });
  }

  getSubcollection(dataType: string, collectionId: string) {
    return getDocs(query(collection(this.firestore, dataType + '/' + collectionId)));
  }

  getSubcollectionSnapshot(dataType: string, collectionId: string, func: any, order: any = false, limitRecs: any = false, start: any = false, whereCond: any = false, first = false) {
    let whereConds: any[] = [];
    if (Array.isArray(whereCond)) {
      whereCond.forEach((val: any) => {
        if (Array.isArray(val)) {
          const conds: any = [];
          val.forEach((v: any) => {
            conds.push(where(v.fld, v.op, v.val));
          });
          if (val[0].type && val[0].type == 'or') {
            // whereConds.push(or(...conds));
            whereConds = [...whereConds, or(...conds)];
          } else {
            whereConds = [...whereConds, ...conds];
          }
        } else {
          whereConds.push(where(val.fld, val.op, val.val));
        }
      });
    }
    if (!order) {
      order = 'id';
    }
    if (order.includes(' ')) {
      order = orderBy(order.split(' ')[0], order.split(' ')[1]);
    } else {
      order = orderBy(order);
    }
    if (limitRecs) {
      if (start) {
        if (first) {
          if (whereConds.length) {
            return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), ...whereConds, order, limit(limitRecs), startAt(start)), func);
          } else {
            return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), order, limit(limitRecs), startAt(start)), func);
          }
        } else {
          if (whereConds.length) {
            return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), ...whereConds, order, limit(limitRecs), startAfter(start)), func);
          } else {
            return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), order, limit(limitRecs), startAfter(start)), func);
          }
        }
      } else {
        if (whereConds.length) {
          return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), ...whereConds, order, limit(limitRecs)), func);
        } else {
          return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), order, limit(limitRecs)), func);
        }
      }
    } else if (whereConds.length) {
      return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), ...whereConds, order), func);
    } else {
      return onSnapshot(query(collection(this.firestore, dataType + '/' + collectionId), order), func);
    }
    // return collectionSnapshots(query(collection(this.firestore, dataType + '/' + collectionId)));
  }

  getSubcollectionChanges(dataType: string, collectionId: string) {
    return collectionChanges(query(collection(this.firestore, dataType + '/' + collectionId)));
  }

  querySubcollection(dataType: string, collectionId: string, fld: string, cond: WhereFilterOp, val: any) {
    const ref = collection(this.firestore, dataType + '/' + collectionId);
    return getDocs(query(ref, where(fld, cond, val)));
  }

  storeSubcollection(dataType: string, collection: string, data: any, merge = false) {
    const docReference = doc(this.firestore, `${dataType}/${collection}`, data.id);
    return setDoc(docReference, data, { merge: merge })
  }

  updateSubcollection(dataType: string, collection: string, data: any) {
    const dataReference = doc(
      this.firestore,
      `${dataType}/${collection}`,
      data.id
    );
    // if (!dataReference.exists()) {
    //   return this.storeSubcollection(dataType, collection, data);
    // }
    return setDoc(dataReference, { ...data }, { merge: true });
  }

  update(dataType: string, data: any) {
    const dataReference = doc(
      this.firestore,
      `${dataType}/${data.id}`
    );
    if (dataReference) {
      return updateDoc(dataReference, { ...data });
    }
    return Promise.resolve(false);
  }

  /**
   * Realiza una consulta de collection group en Firestore
   * @param collectionName - Nombre de la colección a consultar
   * @param conditions - Array de condiciones donde cada condición tiene { field, op, val }
   * @param order - Opcional: ordenamiento { field, direction }
   * @param limitCount - Opcional: límite de resultados
   * @returns Promise con el snapshot de los documentos
   */
  async getCollectionGroup(
    collectionId: string,
    filters?: {
      field: string;
      operator: WhereFilterOp;
      value: any;
    }[],
    orderField?: string,
    orderDirection?: 'asc' | 'desc',
    limitCount?: number
  ): Promise<any[]> {
    try {
      // Start with the collection group reference
      let q = collectionGroup(this.firestore, collectionId);

      // Apply filters if provided
      if (filters && filters.length > 0) {
        const whereConstraints = filters.map(filter =>
          where(filter.field, filter.operator, filter.value)
        );
        q = query(q, ...whereConstraints);
      }

      // Apply ordering if specified
      if (orderField) {
        q = query(q, orderBy(orderField, orderDirection || 'asc'));
      }

      // Apply limit if specified
      if (limitCount) {
        q = query(q, limit(limitCount));
      }

      const querySnapshot = await getDocs(q);
      const results: any[] = [];

      querySnapshot.forEach((doc) => {
        results.push({
          id: doc.id,
          ...doc.data()
        });
      });

      return results;
    } catch (error) {
      console.error('Error getting collection group:', error);
      throw error;
    }
  }

  delete(dataType: string, id: string) {
    const dataReference = doc(
      this.firestore,
      `${dataType}/${id}`
    );
    return deleteDoc(dataReference);
  }
}
